import React, { useContext, useState, useEffect } from 'react';
import { StateController } from './../../App';
import Container from '../../layouts/Container/Container';
import { useMediaQuery } from 'react-responsive';
import ProgressBar from '../atoms/ProgressBar';
import GoalCounter from '../atoms/GoalCounter';
import Button from '../atoms/Button';
import PrimaryBanner from '../molecules/PrimaryBanner';
import Preloader from '../atoms/Preloader';
import useWidth from '../../hooks/useWidth';
import {getPrice, sendDataLayer } from '../../utils/functions';
import ModalPush from '../molecules/ModalPush';
import Modal from '../molecules/Modal';

function Progress() {
  const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });
  const { context } = useContext(StateController);
  const [showToolTip, setShowToolTip] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [showPushModal, setShowPushModal] = useState(false);

  const [isHovered, setIsHovered] = useState(false);

  const { width } = useWidth();
  const { tracing, user, stage } = context;
  console.log(tracing, "tracing", user, "user", stage, "stage");
  // console.log(context, "este es mi context");


  const layer = () => {
    sendDataLayer({ datalayer: { event: 'progress', text: 'Redimir premio >', link: '/premios' }, repeat: true });
  };

  const layerGet = () => {
    sendDataLayer({datalayer: { event: 'progress', text: 'Descubre cómo lograrlo', link: '/premio-mayor' },repeat: true})
  }
  const layerTerms = () => {
    sendDataLayer({datalayer: { event: 'progress', text: 'Ver términos y condiciones', link: '/terminos-y-condiciones' },repeat: true})
  }

  const isGoalMet1 = tracing ? tracing.amount_1 >= user.goal_amount_1 : false;
  const isGoalMet2 = tracing ? tracing.amount_2 >= user.goal_amount_2 : false;

  const progressPercent1 = tracing ? (tracing.amount_1 / user.goal_amount_1) * 100 : 0;
  const progressPercent2 = tracing ? (tracing.amount_2 / user.goal_amount_2) * 100 : 0;

  const closeToolTip = () => {
    setShowToolTip(false)
  }
  
  const scrollToInfoSection = () => {
    const seccion = document.querySelector(".mc-goal-counter");

    if (seccion) {
      seccion.scrollIntoView({ behavior: "smooth" });
    }

    sendDataLayer({ datalayer: { event: 'scroll_button', text: '¿Vamos por más?', link: 'N/A', site_url: '/progreso' }, repeat: true })
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  useEffect(() => {
    console.log("context", context)

    if (context) {
      if (!context || !context.user) {
        // setShowToolTip(true)
        return <Preloader type="section" invert />;
        
      }

      if (context && context.tracing) {
        
        if (context.tracing.winner_1 == 1) {
          const stage = context.redemtions.find((redemtion) => redemtion.block = 1)
  
          if (!stage) {
            setShowToolTip(true)
            setShowPushModal(true)
          }
        }

        if (context.tracing.winner_2 == 1) {
          const stage = context.redemtions.find((redemtion) => redemtion.block = 2)
  
          if (!stage) {
            setShowToolTip(true)
          }
        }
      }
    }
  }, [context])

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className={`mc-page progress slow_ani ${showToolTip ? 'is-tooltip' : ''}`}>

      <Modal
        show={showModal}
        onClose={handleCloseModal}
        // title="¡Gracias por participar!"
        // text="Como viste tú y tu Tarjeta Mastercard <br/> hacen el mejor Match. Prepárate, porque <br/> viene mucho más."
        text="La campaña terminó y los bonos se agotaron. ¿Te queda alguno por descargar? Hazlo antes del 30 de junio de 2025."
        // subtext="Tienes desde el 4 de junio de 2024 hasta el 08 de agosto de 2024"
        imageUrl={`/assets/images/award_end_campaing.png`}
      />


      <ModalPush
        show={showPushModal}
        onClose={setShowPushModal}
        title="¡No olvides redimir tu bono!"
        // text="Como viste tú y tu Tarjeta Mastercard <br/> hacen el mejor Match. Prepárate, porque <br/> viene mucho más."
        text="Tienes hasta el 1 de junio de 2025. <br />¡Apúrate!"
        // subtext="Tienes desde el 4 de junio de 2024 hasta el 08 de agosto de 2024"
        imageUrl={`/assets/images/redencion_pendiente.png`}
      />

    {showToolTip && 
        <div className='big-tooltip'>
          <Container>
            Tienes un bono pendiente por redimir. ¡Disfrútalo ya y sigue avanzando!
            <button onClick={closeToolTip}>
              <img src='/assets/images/close-icon.svg' />
            </button>
          </Container>
        </div>
      }

      {width > 992 && (
        <PrimaryBanner
          image="banner_mechanic_desktop.png"
        />
      )}
      <Container>
        <h1 className='informationTextTitle'>Tu progreso</h1>
        <p className='informationTextParSmall' style={{ maxWidth: '688px', width: 'auto', margin: '0 auto' }}>
          Cada vez que usas tu Tarjeta de Crédito Credencial - Mastercard, dices Sí a la oportunidad de convertir tus compras en premios.
        </p>

        <div className='mc-progress__info'>
          <div className={`mc-progress__info--card ${context?.tracing?.extra == '1' ? 'only-may-goal' : ''} ${isGoalMet1 ? 'blue_class is-winner-card' : 'blue_class'} ${progressPercent1 == 0 ? 'noProgress': ''} ${!isGoalMet1 ? 'noActive' : ''}`}>
            <h2>Meta abril</h2>
            <p>Cumple tu meta antes del 30 de abril</p>
            <div className='mc-progress__info--card__label'>
              {!isGoalMet1
                ? <>
                    Llevas {tracing ? getPrice(tracing.amount_1) : '$0'}
                    <span>de {getPrice(user?.goal_amount_1)}</span>
                  </>
                : <>
                    ¡Muy bien!
                    <span className='winner-extra-label'>Alcanzaste tu meta, ya puedes redimir tu premio.</span>
                  </>
              }
              
            </div>
            {!isGoalMet1 &&
              <span className='dateTexts'>
                Se registraron las compras que realizaste desde el 01/04/2025 hasta el 30/04/2025.
              </span>
            }
            <ProgressBar
              percent={progressPercent1}
              isGoalMet={isGoalMet1}
            />
            {context?.tracing?.winner_1 === 1 ? (
              <div onClick={layer}>
                <Button
                  type="primary"
                  text={'Redimir premio >'}
                  loading={false}
                  status={stage === 2 ? 'inactive' : 'active'}
                  link="/premios"
                />
              </div>
            ) : (
              <div>
                <Button
                  imgl={'lock.png'}
                  type="primary"
                  text={'Redimir premio'}
                  loading={false}
                  status={'inactive'}
                  link="/premios"
                />
              </div>
            )}
          </div>

          <div className={`mc-progress__info--card ${context?.tracing?.extra == '1' ? 'blue_class replace-no-active' : ''} ${isGoalMet2 ? 'blue_class is-winner-card' : 'blue_class'} ${context.block == 1 && progressPercent1 < 100 ? '' : ''}`}>
            <h2>Meta mayo</h2>
            <p>Cumple tu meta antes del 15 de junio</p>
            <div className='mc-progress__info--card__label'>
              {!isGoalMet2
                ? <>
                    Llevas {tracing ? getPrice(tracing.amount_2) : '$0'}
                    <span>de {getPrice(user?.goal_amount_2)}</span>
                  </>
                : <>
                    ¡Muy bien!
                    <span className='winner-extra-label'>Alcanzaste tu meta, ya puedes redimir tu premio.</span>
                  </>
              }
            </div>

            {!isGoalMet2 &&
              <span className='dateTexts'>
                Se registraron las compras que realizaste desde el 01/05/2025 hasta el 06/06/2025.
              </span>
            }
            
            <ProgressBar
              percent={progressPercent2}
              isGoalMet={isGoalMet2}
            />
            {context?.tracing?.winner_2 === 1 ? (
              <div onClick={layer}>
                <Button
                  type="primary"
                  text={'Redimir premio >'}
                  loading={false}
                  status={'active'}
                  link="/premios"
                />
              </div>
            ) : (
              <div>
                <Button
                  imgl={'lock.png'}
                  type="primary"
                  text={'Redimir premio'}
                  loading={false}
                  status={'inactive'}
                  link="/premios"
                />
              </div>
            )}
          </div>
          {isDesktop &&
            <div onClick={scrollToInfoSection} className='arrow-down-container-desktop'>
              <a style={{ cursor: 'Pointer' }}>
                <img
                  className={`arrow-down ${isHovered ? 'hover' : ''}`}
                  src={`/assets/images/scroll-down-progress.png`}
                  alt=""
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                />
              </a>
            </div>
          }
        </div>

        <GoalCounter
          label={`Has cumplido tu meta:`}
        />

        <div className="banner-major-award">
          <a href="/premio-mayor" target='_blank' onClick={layerGet}></a>
          <a className="link-terms" href="/terminos-y-condiciones" target='_blank' onClick={layerTerms}></a>
          <img src={`/assets/images/banner-premio-mayor${width < 992 ? '-m' : ''}.svg`} />
        </div>

        
      </Container>

    </div>
  );
}

export default Progress;
